import jsonLogic from 'json-logic-js'
import { isArray, isObject } from 'lodash'

jsonLogic.add_operation('not_in_like', (data, rules) => {
  let validFlag = true

  rules.forEach(rule => {
    const regex = new RegExp(rule, 'g')

    if (!!data && data.match(regex)) validFlag = false
  })

  return validFlag
})

jsonLogic.add_operation('in_like', (data, rules) => {
  let validFlag = false

  rules.forEach(rule => {
    const regex = new RegExp(rule, 'g')

    if (!!data && data.match(regex)) validFlag = true
  })

  return validFlag
})

function isLogical(value) {
  if (!Array.isArray(value)) {
    return false
  }

  if (Array.isArray(value[0])) {
    return false
  }

  return value.length === 2 || value.length === 3
}

function parseRules(rules) {
  if (!isArray(rules) && !isObject(rules)) {
    return null
  }

  if (isLogical(rules)) {
    rules = [rules]
  }

  if (!isArray(rules) || rules.length === 0) {
    return null
  }

  const parsedRules = rules.map((rule, index) => {
    if (!isLogical(rule)) {
      return null
    }

    let variable, operator, value

    if (rule.length === 3) {
      [variable, operator, value] = rule
    } else {
      value = null;
      [variable, operator] = rule
    }

    return {
      and: [
        { '==': [{ var: 'code' }, variable] },
        { [operator]: [{ var: 'value' }, value] }
      ]
    }
  })

  return parsedRules.filter(rule => rule !== null)
}

class Logic {
  constructor(rules) {
    this.rules = parseRules(rules)
  }

  evaluate(data, debug = false) {
    if (!this.rules) {
      return true
    }

    const requireNumberConditionMatch = this.rules.length
    let numberOfConditionMatch = 0

    data.forEach(selectedData => {
      this.rules.forEach(rule => {
        if (jsonLogic.apply(rule, selectedData)) numberOfConditionMatch++
      })
    })

    return numberOfConditionMatch === requireNumberConditionMatch
  }
}

export {
  Logic,
  parseRules
}
